var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpresarial(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65 63.5",
    style: {
      enableBackground: "new 0 0 65 63.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9B0008;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.1,8.5H45.3V3.9c0-0.3-0.2-0.7-0.5-0.9C38-1,27-1,20.2,3.1c-0.3,0.2-0.5,0.5-0.5,0.8v4.6H6.9 C3.1,8.5,0,11.6,0,15.4v36.4c0,3.8,3.1,6.9,6.9,6.9h2.2v1.8c0,1.6,1.3,3,2.9,3h5.5c1.6,0,3-1.4,3-3v-1.8h24v1.8c0,1.7,1.3,3,3,3 H53c1.7,0,3-1.3,3-3v-1.8h2.3c3.8-0.1,6.8-3.1,6.8-6.9V15.4C65,11.6,61.9,8.5,58.1,8.5z M21.7,4.5c6.1-3.4,15.5-3.4,21.6,0v4.1 H21.7V4.5z M2,15.4c0-2.7,2.2-4.9,4.9-4.9h51.2c2.7,0,4.9,2.2,4.9,4.9v11.2c-6.6,3.9-14.8,6.2-23.4,7.1c-0.1-2.1-1.8-3.8-3.9-3.8 h-6.9c-2.1,0-3.8,1.7-3.9,3.8c-8-0.7-15.8-3.1-22.9-7V15.4z M8.4,31.8c5.3,2,10.9,3.3,16.5,3.8v0.2c0,2.2,1.8,3.9,4,4h6.9 c2.2,0,3.9-1.8,3.9-4v-0.2c5.8-0.5,11.5-1.8,17-3.8v17.6c0,0.6-0.4,1-1,1H9.4c-0.6,0-1-0.4-1-1L8.4,31.8z M26.9,35.8v-2 c0-1.1,0.9-2,2-2h6.9c1.1,0,2,0.9,2,2v2c0,1.1-0.9,2-2,2h-6.9C27.7,37.8,26.9,36.9,26.9,35.8z M18.5,60.5c0,0.6-0.4,1-1,1H12 c-0.6,0-1-0.4-1-1v-1.8h7.5V60.5z M53.9,60.5c0,0.6-0.4,1-1,1h-5.5c-0.6,0-1-0.4-1-1v-1.8h7.5L53.9,60.5z M58.1,56.8H6.9 c-2.7,0-4.9-2.2-4.9-4.9v-23c1.4,0.8,2.9,1.5,4.4,2.1v18.4c0,1.7,1.3,3,3,3h46.2c1.7,0,3-1.3,3-3V31c1.5-0.7,3-1.4,4.4-2.2v23 C63.1,54.6,60.9,56.8,58.1,56.8C58.2,56.8,58.1,56.8,58.1,56.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresarial);
export default __webpack_public_path__ + "static/media/empresarial.157f5524db600f13152f97774468cc3b.svg";
export { ForwardRef as ReactComponent };